var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-list-item",class:{
    active: _vm.active,
    'no-padding': _vm.noPadding,
    'with-border': _vm.withBorder,
    column: _vm.direction === 'column',
    disabled: _vm.disabled,
  },style:({ width: `${_vm.itemWidthPercentage}%` }),on:{"click":e => this.$emit('click', e)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }